<template>
  <div class="personal-drill-record-card-comp">
    <div class="header">
      <div class="wrapper">
        <div class="title">{{ seq }}、{{ name }}</div>
      </div>
      <div class="tip">运动{{ drillInfos.length }}次</div>
    </div>

    <div
      class="drill-info"
      v-for="(drill, index) in drillInfos"
      @click="showDrillReportPopup(drill.drill_record_id)"
      :key="index"
    >
      <div class="detail-info">
        <div class="item">
          <div class="wrapper">
            <div class="name">{{ drill.name }}</div>
            <div class="detect-info" v-if="!!drill.ai_detect_label">AI检测结果为{{ drill.ai_detect_label }}</div>
          </div>
          <div class="time">{{ formatTime(drill.time) }}</div>
        </div>

        <div class="item">
          <div class="name">运动时长</div>
          <div class="value">
            <span>{{ formatDuration(drill.duration) }}</span> 分钟
          </div>
        </div>

        <div class="item">
          <div class="name">得分评价</div>
          <div class="value">
            <span>{{ drill.star_score }}</span>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="showDrillReport" v-if="showDrillReport">
      <drill-report :id="currentDrillReportId" :show-illegal-btn="false" :show-rank-down-btn="false"></drill-report>
    </el-dialog>
  </div>
</template>
<script lang="ts">
import { BaseComponent, Component, Prop } from 'kuaidong-component'
import { IChallengeDrillRecord } from 'kuaidong-model'
import { DateUtil, DateWrapper } from 'kuaidong-lib'
import DrillReport from '@/components/DrillReport.vue'
@Component({
  components: { DrillReport },
})
export default class PersonalDrillRecordCard extends BaseComponent {
  @Prop({ type: String, required: true })
  name!: string

  @Prop({ type: Number, required: true })
  seq!: number

  @Prop({ type: Array, required: true })
  drillInfos!: IChallengeDrillRecord[]

  showDrillReport = false
  currentDrillReportId = ''
  formatTime(dt: string) {
    return new DateWrapper(dt).showCustomStr
  }

  formatDuration(ms: number) {
    return DateUtil.millisecond2minutes(ms)
  }

  showDrillReportPopup(id: string) {
    this.currentDrillReportId = id
    this.showDrillReport = true
  }
}
</script>
<style lang="less">
.personal-drill-record-card-comp {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  > .header {
    display: flex;
    justify-content: space-between;
    > .title {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #4d4d4d;
    }
    > .tip {
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
      color: #8f8f8f;
    }
  }

  > .drill-info {
    background: #f7f8fa;
    border-radius: 8px;
    padding: 16px;
    margin-top: 14px;
    > .first-line {
      display: flex;
      justify-content: space-between;
    }

    > .detail-info {
      display: flex;
      justify-content: space-between;
      > .item {
        margin-top: 12px;
        display: flex;
        flex-direction: column;
        width: 50%;
        align-content: flex-start;
        align-items: flex-start;
        justify-content: flex-start;

        > .wrapper {
          display: flex;
          align-items: center;
          > .name {
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: #2d2f33;
            &:hover {
              color: var(--shs-theme-primary);
              cursor: pointer;
            }
          }
          > .detect-info {
            padding: 4px;
            border: 1px solid #f24b53;
            border-radius: 4px;
            font-weight: 400;
            font-size: 10px;
            line-height: 10px;
            color: #f24b53;
            margin-left: 8px;
          }
        }
        > .time {
          font-weight: 400;
          font-size: 12px;
          line-height: 17px;
          color: #8f8f8f;
          margin-top: 12px;
        }

        > .name {
          font-weight: 400;
          font-size: 12px;
          line-height: 17px;
          color: #8f8f8f;
        }
        > .value {
          margin-top: 6px;
          font-weight: 500;
          font-size: 12px;
          line-height: 12px;
          color: #4d4d4d;
          > span {
            font-weight: 600;
            font-size: 20px;
            line-height: 24px;
            color: #2d2f33;
          }
        }
      }
    }
  }
}
</style>
